import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { SessionContext } from "../../models/session-context.model";
import { Observable, Subscription } from "rxjs";
import { UserInfoService } from "../../services/user-info.service";
import { PatientRole } from "../../models/patient-role.model";
import { getPathWithoutQueryAndHash } from "../utils/url.utils";

const EXTERNAL_ALLOWED_EXACT_PATHS = new Set([
  "/",
  "/user-profile",
  "/contact-info",
  "/login",
  // Post-login biometric enroll/reminder (refresh or AuthGuard re-entry from "/").
  "/login/biometrics-enroll",
  "/more",
  "/message",
]);

function isAllowedExternalPatientPath(url: string): boolean {
  const path = getPathWithoutQueryAndHash(url);
  if (EXTERNAL_ALLOWED_EXACT_PATHS.has(path)) return true;
  if (path.startsWith("/cross-communication")) return true;
  return false;
}

@Injectable({
  providedIn: "root",
})

export class ExternalPatientRoleGuard {

  sessionContext!: SessionContext;
  private subs: Subscription[] = [];

  constructor(
    public router: Router,
    public userService: UserInfoService,
  ) {
    this.subs.push(
      this.userService.sessionContext.subscribe((context: SessionContext) => {
        this.sessionContext = context;
      }),
    );
  }

  canActivate: CanActivateFn = (_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
    if (!this.sessionContext?.patientRole) {
      return true;
    }

    const isRestrictedExternalPatient =
      this.sessionContext.patientRole === PatientRole.EXTERNAL;

    if (isRestrictedExternalPatient && !isAllowedExternalPatientPath(state.url)) {
      this.router.navigate(["/"]);
      return false;
    }

    return true;
  };

  ngOnDestroy() {
    this.subs.forEach((sub) => sub.unsubscribe());
  }
}
